import { useContext } from 'react';
import MobileMenuContext from 'src/contexts/MobileMenuContext/MobileMenuContext';

const useMobileMenu = () => {
  return useContext(MobileMenuContext);
};

export default useMobileMenu;
